import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";
import { categories } from "@/mocks/categories";
import VideoCard from "@/components/feature/VideoCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { formatCount } from "@/utils/format";
import HeroCarousel from "./components/HeroCarousel";
import HomeSearchBand from "./components/HomeSearchBand";
import CategoryGrid from "./components/CategoryGrid";

export default function Home() {
  const latest = [...videos].sort((a, b) => b.publishTime.localeCompare(a.publishTime)).slice(0, 8);
  const hot = [...videos].sort((a, b) => b.views - a.views).slice(0, 6);
  const totalViews = videos.reduce((acc, v) => acc + v.views, 0);

  return (
    <div className="w-full pb-16">
      <HeroCarousel />

      <div className="mt-8 md:mt-10">
        <HomeSearchBand />
      </div>

      <CategoryGrid />

      <section className="w-full px-4 pb-10 md:px-8 md:pb-14">
        <SectionHeading
          title="最新视频"
          subtitle="按发布时间排序，第一时间掌握娱乐风向"
          icon="ri-time-line"
          linkHref="/category/star"
          linkLabel="浏览更多"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {latest.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </section>

      <section className="w-full border-y border-background-200 bg-background-100">
        <div className="w-full px-4 py-10 md:px-8 md:py-14">
          <SectionHeading
            title="热门视频推荐"
            subtitle="根据播放量与网友热议程度综合排序"
            icon="ri-fire-line"
          />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
            {hot.map((video, i) => (
              <div key={video.id} className="relative">
                <span
                  className={`absolute -left-1 -top-1 z-10 flex h-8 w-8 items-center justify-center rounded-md text-sm font-black ${
                    i < 3 ? "bg-primary-500 text-background-50" : "bg-secondary-500 text-background-50"
                  }`}
                >
                  {i + 1}
                </span>
                <VideoCard video={video} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-information-line text-sm" />
              </span>
              关于吃瓜视频
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug tracking-tight text-foreground-950 md:text-3xl">
              一个有热度的娱乐视频资讯门户
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base">
              吃瓜视频专注于娱乐视频资讯与热点内容，覆盖明星动态、社会热点、趣味短片、影视资讯、音乐现场与游戏电竞等多个方向。
              我们希望用更快的速度、更清晰的分类和更舒适的观看体验，让每一条值得关注的内容都不被错过。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                了解我们
              </Link>
              <Link
                to="/search"
                className="rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-300 hover:text-accent-600 whitespace-nowrap"
              >
                开始搜索
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="font-heading text-3xl font-black text-primary-500">{videos.length}</p>
              <p className="mt-1 text-sm text-foreground-600">在库视频</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="font-heading text-3xl font-black text-accent-600">{categories.length}</p>
              <p className="mt-1 text-sm text-foreground-600">内容分类</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="font-heading text-3xl font-black text-primary-500">{formatCount(totalViews)}</p>
              <p className="mt-1 text-sm text-foreground-600">累计播放</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="font-heading text-3xl font-black text-accent-600">每日</p>
              <p className="mt-1 text-sm text-foreground-600">持续更新</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}